export default __webpack_public_path__ + "static/media/logo_payvalis.647f6782.png";